module.exports = __webpack_public_path__ + "static/reading@2x-82950b06b2c50a79dc0b453d9732c0da.png";